/**
 * @generated SignedSource<<d460e00ecbf408ba2eeb80008894a25e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StreamInviteRowResendStreamInviteMutation$variables = {
  captchaToken: string;
  id: string;
};
export type StreamInviteRowResendStreamInviteMutation$data = {
  readonly noteStreamResendStreamInvite: {
    readonly invite: {
      readonly id: string;
      readonly isExpired: boolean;
    } | null;
  } | null;
};
export type StreamInviteRowResendStreamInviteMutation = {
  response: StreamInviteRowResendStreamInviteMutation$data;
  variables: StreamInviteRowResendStreamInviteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "captchaToken"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "captchaToken",
        "variableName": "captchaToken"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "NoteStreamResendStreamInvite",
    "kind": "LinkedField",
    "name": "noteStreamResendStreamInvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStreamInvite",
        "kind": "LinkedField",
        "name": "invite",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isExpired",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamInviteRowResendStreamInviteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StreamInviteRowResendStreamInviteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "12e73e6c1838e68317195e2a9d122c6f",
    "id": null,
    "metadata": {},
    "name": "StreamInviteRowResendStreamInviteMutation",
    "operationKind": "mutation",
    "text": "mutation StreamInviteRowResendStreamInviteMutation(\n  $id: ID!\n  $captchaToken: String!\n) {\n  noteStreamResendStreamInvite(id: $id, captchaToken: $captchaToken) {\n    invite {\n      id\n      isExpired\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "616b2c8c652457594283eeeadc3d2a3d";

export default node;
